export default __webpack_public_path__ + "static/char-s-04-kr-5740ca4c4bc64d290f4cfa20f58cb9aa.webp";